import React, { memo, useEffect, useMemo, useState } from 'react';
import { Button, Tooltip } from '@material-ui/core';
import SmileDesignNewCaseModal from './Modal/SmileDesignNewCaseModal';
import { useLang } from '../../util/lang';
import { usePatientsStyles } from '../../style/usePatientsStyles';
import { fetchUserTest } from '../../api/userTest';
import { useImmer } from 'use-immer';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CreateButton from '../../components/Button/CreateButton/CreateButton';

const extractSmileDesignProductName = (name) => {
    const text = name;
    const pattern = /^(\w+)\sSmile Design$/;

    const match = text.match(pattern);
    if (match) {
        const extractedText = match[1];
        return extractedText;
    } else {
        return '';
    }
};

export const useCaseConfig = {
    new_case_home_page: 'new_case_home_page',
    new_case_patient_page: 'new_case_patient_page',
};

/**
 * Renders the smile design case creation button.
 */
const SmileDesignCreateCaseButton = ({
    useCase = useCaseConfig.new_case_home_page,
    disable = false,
    ClassProps = undefined,
    patientId = undefined,
}) => {
    const classes = usePatientsStyles();
    const { productMatrixArray, productList } = useSelector((state) => state.smileDesign);
    const displayFirstFitFlag = useSelector((state) => state.globalReducer.displayFirstFitFlag);
    const [isOpen, setIsOpen] = useState(false);
    const get = useLang();
    const [allowFeature, setAllowFeature] = useImmer({});
    const history = useHistory();

    const isMarieGroup = useMemo(() => {
        let value = JSON.parse(localStorage.getItem('isMarieGroup'));
        return value;
    }, []);

    const onlyFullSmileDesign = useMemo(() => {
        if (productMatrixArray.length !== 0) {
            const fullSmileDesign = productMatrixArray.find((v) => /FULL_SMILE_DESIGN/.test(v.case_type)); // Find the full smile design case
            return fullSmileDesign ? fullSmileDesign.case_type : null;
        }
        return null;
    }, [productMatrixArray]);

    const handleOnclickNavigateCreateSmileDesignCase = () => {
        if (onlyFullSmileDesign && patientId) {
            history.push(`/patients/${patientId}/newCase/${onlyFullSmileDesign}`);
        } else {
            history.push(`/patients/newPatient/${onlyFullSmileDesign}`);
        }
    };

    useEffect(() => {
        async function getUserTestResult() {
            const fetchUserTestResult = await fetchUserTest();
            setAllowFeature(fetchUserTestResult);
        }
        getUserTestResult();
    }, []);

    const CreateCaseButton = useMemo(() => {
        switch (useCase) {
            case useCaseConfig.new_case_patient_page: {
                return (
                    <Button className={ClassProps} onClick={() => setIsOpen(true)} disabled={disable}>
                        {get('@PatientInfo.case_info.actionsList.createNewCaseForPatient')}
                    </Button>
                );
            }

            default: {
                return (
                    <>
                        {
                            <>
                                {!allowFeature?.['smile_design'] ? (
                                    <Tooltip
                                        title={
                                            <div style={{ margin: 10 }}>
                                                <div style={{ fontSize: '15px' }}>
                                                    {get(`@PatientInfo.msg.smileDesignTip`)}
                                                </div>
                                            </div>
                                        }
                                        aria-label="add"
                                        PopperProps={{
                                            style: { marginTop: '-20px' }, // Adjust the top margin here as needed
                                        }}
                                        interactive
                                        arrow
                                    >
                                        <div>
                                            <CreateButton
                                                onClick={handleOnclickNavigateCreateSmileDesignCase}
                                                name={get(
                                                    displayFirstFitFlag
                                                        ? '@Patients.newIntegrativeSmileDesignFirstFit'
                                                        : '@Patients.newIntegrativeSmileDesign'
                                                )}
                                                displayFirstFitFlag={displayFirstFitFlag}
                                                disabled={!allowFeature?.['smile_design']}
                                                icon="/img/createCase/createCaseIcon/button_icon2.png"
                                            />
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <div>
                                        <CreateButton
                                            onClick={handleOnclickNavigateCreateSmileDesignCase}
                                            displayFirstFitFlag={displayFirstFitFlag}
                                            name={get(
                                                displayFirstFitFlag
                                                    ? '@Patients.newIntegrativeSmileDesignFirstFit'
                                                    : '@Patients.newIntegrativeSmileDesign'
                                            )}
                                            disabled={!allowFeature?.['smile_design']}
                                            icon="/img/createCase/createCaseIcon/button_icon2.png"
                                        />
                                    </div>
                                )}
                            </>
                        }
                    </>
                );
            }
        }
    }, [
        isMarieGroup,
        useCase,
        disable,
        ClassProps,
        allowFeature,
        displayFirstFitFlag,
        get,
        handleOnclickNavigateCreateSmileDesignCase,
    ]);

    return (
        <>
            {CreateCaseButton}
            <SmileDesignNewCaseModal isOpen={isOpen} setIsOpen={setIsOpen} patientId={patientId} />
        </>
    );
};

export default memo(SmileDesignCreateCaseButton);
